var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodSnacks = function SvgFoodSnacks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.345 12.6a9.4 9.4 0 0 1-.245-2.003c0-1.402.359-2.268.697-2.744q.102-.144.207-.253m5.596-3v-.764c0-1.37-.774-2.623-2-3.236m2 3.995c-2 0-2.936-1.368-5.436-.896S.6 6.596.6 10.597 3.1 20.6 6.6 20.6c1.5 0 2.5-1 4-1s2.5 1 4 1c3.5 0 6-6.002 6-10.003S18.536 4.171 16.036 3.7s-3.436.896-5.436.896"
  })));
};
export default SvgFoodSnacks;